var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChessPawn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.125 224H80C71.125 224 64 231.125 64 240V272C64 280.875 71.125 288 80 288H96V293.5C96 337.5 91.875 380.125 72 416H248C228.125 380.125 224 337.5 224 293.5V288H240C248.875 288 256 280.875 256 272V240C256 231.125 248.875 224 240 224H214.875C244.25 205.625 264 173.25 264 136C264 78.5 217.5 32 160 32S56 78.5 56 136C56 173.25 75.75 205.625 105.125 224ZM272 448H48C21.49 448 0 469.49 0 496V496C0 504.837 7.163 512 16 512H304C312.837 512 320 504.837 320 496V496C320 469.49 298.51 448 272 448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessPawn);
export default __webpack_public_path__ + "static/media/chess-pawn.ca437d490e5c462d482e8f75db2c4b5f.svg";
export { ForwardRef as ReactComponent };